import { RecentBookingsCard } from '../../components/bookings/RecentBookingsCard'
import { BookingServicesCard } from '../../components/charts/BookingServicesCard'
import { RevenueOverviewCard } from '../../components/charts/RevenueOverviewCard'
import { DashboardLayout } from '../../components/layout/DashboardLayout'
import { StatCardRow } from './components/stats/StatCardRow'
import { UpcomingTripsCard } from './components/trips/UpcomingTripsCard'
import { shellAssets } from '../../constants/assets'
import { useDashboardOverview } from '../../hooks/useDashboardOverview'

const DashboardPage = () => {
  const { overview, loading, error, warning, reload } = useDashboardOverview()

  const user = overview?.user ?? {
    name: 'Admin',
    email: 'Admin@123gmail.com',
    avatar: shellAssets.avatar,
  }

  const subtitle =
    overview?.welcomeSubtitle ??
    "Welcome back, Admin! Here's what's happening today."

  return (
   <DashboardLayout
  activeNavId="dashboard"
  title="Dashboard"
  subtitle={subtitle}
  user={user}
>
  {/* Browser document handles vertical scrolling */}
<div className="flex min-h-0 w-full flex-col lg:h-[calc(100dvh-185px)] lg:overflow-hidden">
  {loading ? (
    <div className="flex min-h-[420px] flex-1 flex-col items-center justify-center gap-3 rounded-[18px] bg-white shadow-dash-panel">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-[#365E92]" />

      <p className="font-host text-[14px] text-dash-muted">
        Loading dashboard overview…
      </p>
    </div>
  ) : error || !overview ? (
    <div className="flex min-h-[320px] flex-1 flex-col items-center justify-center gap-4 rounded-[18px] bg-white px-6 text-center shadow-dash-panel">
      <p className="font-host text-[16px] font-medium text-black">
        {error || 'Unable to load dashboard overview.'}
      </p>

      {warning ? (
        <p className="max-w-md font-host text-[13px] text-dash-muted">
          {warning}
        </p>
      ) : null}

      <button
        type="button"
        onClick={() => void reload()}
        className="rounded-full bg-[#365E92] px-5 py-2.5 font-host text-[13px] font-semibold text-white transition hover:bg-[#294e7e]"
      >
        Try again
      </button>
    </div>
  ) : (
    <div className="flex min-h-0 flex-1 flex-col gap-[16px]">
      {/* Fixed summary cards */}
      <div className="shrink-0">
        <StatCardRow
          highlightStat={overview.highlightStat}
          stats={overview.stats}
        />
      </div>

      {/* Scroll starts only below summary cards */}
      <div className="min-h-0 flex-1 pr-[6px] lg:overflow-y-auto lg:overscroll-contain">
        <div className="flex flex-col gap-[16px] xl:flex-row xl:items-center xl:gap-0">
          <div className="flex min-w-0 flex-col gap-[16px] xl:w-[802px]">
            <div className="flex flex-col gap-[16px] lg:flex-row lg:items-start lg:justify-between xl:w-[794px] xl:gap-0">
              <RevenueOverviewCard revenue={overview.revenue} />

              <BookingServicesCard
                bookingServices={overview.bookingServices}
              />
            </div>

            <UpcomingTripsCard trips={overview.upcomingTrips} />
          </div>

          <div className="min-w-0 xl:flex-1 xl:pl-[10px]">
            <RecentBookingsCard
              bookings={overview.recentBookings}
            />
          </div>
        </div>
      </div>
    </div>
  )}
</div>
</DashboardLayout>
  )
}

export default DashboardPage
